import * as z from "zod";

export const getSegmentProductVendors = {
  name: "getSegmentProductVendors" as const,
  input: z.null(),
  output: z.array(z.string()),
};
